/* GlobifySIM – live cart
 *
 * Aktualisiert Mengen, Zwischensumme, Anzahl im Kopfbereich und die
 * Vorschläge, ohne die Seite neu zu laden. Fällt bei einem Fehler auf das
 * normale Formular zurück, damit der Warenkorb nie blockiert.
 */
(function () {
  "use strict";

  var T = window.GST || {};
  var format = "{{amount_with_comma_separator}} EUR";

  /* ------------------------------------------------------------- Geldbeträge */

  function trennen(betrag, komma, tausend) {
    var s = (betrag / 100).toFixed(2).split(".");
    var ganz = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, tausend);
    return ganz + komma + s[1];
  }

  function geld(cent) {
    var wert = Number(cent) || 0;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case "amount": return trennen(wert, ".", ",");
        case "amount_no_decimals": return String(Math.round(wert / 100));
        case "amount_with_comma_separator": return trennen(wert, ",", ".");
        case "amount_no_decimals_with_comma_separator": return String(Math.round(wert / 100));
        default: return trennen(wert, ",", ".");
      }
    });
  }

  /* ----------------------------------------------------------- Schnittstelle */

  function holen() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); });
  }

  function aendern(schluessel, menge) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: schluessel, quantity: menge })
    }).then(function (r) {
      if (!r.ok) throw new Error("cart/change " + r.status);
      return r.json();
    });
  }

  function hinzufuegen(variante, menge) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variante), quantity: menge || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error("cart/add " + r.status);
      return r.json();
    });
  }

  /* ----------------------------------------------------------- Animationen */

  function ruhigGewuenscht() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function korbSymbol() {
    return document.querySelector('[data-gs-korbzahl]') ||
           document.querySelector('a[href*="/cart"]');
  }

  /* Ein kleiner Punkt fliegt vom Knopf zum Warenkorb */
  function flug(vonEl) {
    if (ruhigGewuenscht() || !vonEl) return;
    var ziel = korbSymbol();
    if (!ziel) return;
    var a = vonEl.getBoundingClientRect();
    var b = ziel.getBoundingClientRect();
    var punkt = document.createElement("span");
    punkt.className = "gs-flug";
    punkt.style.left = (a.left + a.width / 2) + "px";
    punkt.style.top = (a.top + a.height / 2) + "px";
    punkt.style.setProperty("--gs-dx", (b.left + b.width / 2 - a.left - a.width / 2) + "px");
    punkt.style.setProperty("--gs-dy", (b.top + b.height / 2 - a.top - a.height / 2) + "px");
    document.body.appendChild(punkt);
    window.setTimeout(function () { punkt.remove(); }, 750);
  }

  function korbHuepfen() {
    if (ruhigGewuenscht()) return;
    var el = korbSymbol();
    if (!el) return;
    el.classList.remove("ist-gehuepft");
    void el.offsetWidth;
    el.classList.add("ist-gehuepft");
  }

  /* Zahl weich hochzählen */
  function hochzaehlen(el, von, bis) {
    if (!el) return;
    if (ruhigGewuenscht() || von === bis) { el.textContent = geld(bis); return; }
    var start = null, dauer = 420;
    function schritt(zeit) {
      if (start === null) start = zeit;
      var anteil = Math.min(1, (zeit - start) / dauer);
      var weich = 1 - Math.pow(1 - anteil, 3);
      el.textContent = geld(Math.round(von + (bis - von) * weich));
      if (anteil < 1) window.requestAnimationFrame(schritt);
    }
    window.requestAnimationFrame(schritt);
  }

  function pulsen(el) {
    if (!el || ruhigGewuenscht()) return;
    el.classList.remove("ist-gepulst");
    void el.offsetWidth;
    el.classList.add("ist-gepulst");
  }

  /* Bestätigung, die von rechts hereinfährt und den ganzen Warenkorb zeigt */
  function bestaetigung(neuerPosten, korb) {
    var alt = document.querySelector(".gs-zugefuegt");
    if (alt) alt.remove();

    var kasten = document.createElement("div");
    kasten.className = "gs-zugefuegt";

    var neueKennung = neuerPosten ? neuerPosten.key : null;

    function zeile(posten) {
      var istNeu = posten.key === neueKennung;
      var bild = posten.image
        ? '<img src="' + posten.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") + '" alt="">'
        : '<span class="gs-zugefuegt__ersatz">\u2713</span>';
      var variante = posten.variant_title && posten.variant_title.indexOf("Default") < 0
        ? posten.variant_title : "";
      return '<div class="gs-zugefuegt__zeile' + (istNeu ? " ist-neu" : "") + '">' + bild +
        "<div><b>" + posten.product_title + "</b><small>" + variante +
        (posten.quantity > 1 ? " &middot; " + posten.quantity + "\u00d7" : "") +
        '</small></div><span class="gs-zugefuegt__preis">' + geld(posten.final_line_price) + "</span></div>";
    }

    var posten = korb.items || [];
    var kopfzeile = posten.length > 1
      ? (T.im_warenkorb || "In your cart") + " (" + korb.item_count + ")"
      : (T.hinzugefuegt || "Added to cart");

    kasten.innerHTML =
      '<div class="gs-zugefuegt__kopf"><span class="gs-zugefuegt__haken">\u2713</span>' + kopfzeile + "</div>" +
      '<div class="gs-zugefuegt__liste">' + posten.map(zeile).join("") + "</div>" +
      '<div class="gs-zugefuegt__summe"><span>' + (T.zwischensumme || "Subtotal") + "</span><b>" + geld(korb.total_price) + "</b></div>" +
      (T.lieferzeit ? '<p class="gs-zugefuegt__lieferung">' + T.lieferzeit + "</p>" : "") +
      '<div class="gs-zugefuegt__knoepfe">' +
      '<a class="gs-knopf gs-knopf--leer gs-knopf--klein" href="/cart">' + (T.warenkorb_ansehen || "View cart") + "</a>" +
      '<a class="gs-knopf gs-knopf--signal gs-knopf--klein" href="/checkout">' + (T.kasse || "Checkout") + "</a>" +
      "</div>" +
      '<button type="button" class="gs-zugefuegt__zu" aria-label="Close">&times;</button>';

    document.body.appendChild(kasten);
    window.requestAnimationFrame(function () { kasten.classList.add("ist-da"); });

    /* Zum neu hinzugefügten Posten scrollen, falls die Liste lang ist */
    var neueZeile = kasten.querySelector(".gs-zugefuegt__zeile.ist-neu");
    if (neueZeile) neueZeile.scrollIntoView({ block: "nearest" });

    var weg = window.setTimeout(function () { schliessen(); }, posten.length > 2 ? 9000 : 6500);
    function schliessen() {
      window.clearTimeout(weg);
      kasten.classList.remove("ist-da");
      window.setTimeout(function () { kasten.remove(); }, 320);
    }
    kasten.querySelector(".gs-zugefuegt__zu").addEventListener("click", schliessen);
  }

  /* --------------------------------------------------------------- Anzeige */

  function zahlImKopf(anzahl) {
    var ziel = document.querySelector("[data-gs-korbzahl]");
    var knopf = document.querySelector('a[href*="/cart"]');
    if (ziel) {
      if (ziel.textContent !== String(anzahl)) korbHuepfen();
      ziel.textContent = anzahl;
      ziel.style.display = anzahl > 0 ? "" : "none";
    } else if (knopf && anzahl > 0) {
      var neu = document.createElement("span");
      neu.className = "gs-kopf__zahl";
      neu.setAttribute("data-gs-korbzahl", "");
      neu.textContent = anzahl;
      knopf.appendChild(neu);
    }
  }

  function fortschritt(korb) {
    var leiste = document.querySelector("[data-gs-schwelle]");
    if (!leiste) return;
    var schwelle = parseInt(leiste.getAttribute("data-gs-schwelle"), 10) * 100;
    if (!schwelle) return;
    var balken = leiste.querySelector("[data-gs-schwelle-balken]");
    var text = leiste.querySelector("[data-gs-schwelle-text]");
    var fehlt = schwelle - korb.total_price;
    var anteil = Math.min(100, Math.round((korb.total_price / schwelle) * 100));
    if (balken) balken.style.width = anteil + "%";
    if (text) {
      if (fehlt > 0) {
        text.textContent = (leiste.getAttribute("data-gs-text-offen") || "Add {betrag} more to unlock the offer")
          .replace("{betrag}", geld(fehlt));
        leiste.classList.remove("ist-erreicht");
      } else {
        text.textContent = leiste.getAttribute("data-gs-text-erreicht") || "Offer unlocked";
        leiste.classList.add("ist-erreicht");
      }
    }
  }

  function zeilenZeichnen(korb) {
    var koerper = document.querySelector("[data-gs-korb-zeilen]");
    if (!koerper) return;

    if (!korb.items.length) {
      window.location.reload();
      return;
    }

    korb.items.forEach(function (posten) {
      var zeile = koerper.querySelector('[data-gs-zeile="' + posten.key + '"]');
      if (!zeile) return;
      var summe = zeile.querySelector("[data-gs-zeilensumme]");
      var menge = zeile.querySelector("[data-gs-menge-wert]");
      if (summe && summe.textContent !== geld(posten.final_line_price)) {
        summe.textContent = geld(posten.final_line_price);
        pulsen(summe);
      }
      if (menge && menge.textContent !== String(posten.quantity)) {
        menge.textContent = posten.quantity;
        pulsen(menge);
      }
      var feld = zeile.querySelector("[data-gs-menge-feld]");
      if (feld) feld.value = posten.quantity;
    });

    /* entfernte Zeilen ausblenden */
    var vorhanden = korb.items.map(function (p) { return p.key; });
    var alle = koerper.querySelectorAll("[data-gs-zeile]");
    for (var i = 0; i < alle.length; i++) {
      if (vorhanden.indexOf(alle[i].getAttribute("data-gs-zeile")) < 0) {
        alle[i].remove();
      }
    }
    if (!koerper.querySelectorAll("[data-gs-zeile]").length) window.location.reload();
  }

  function summenZeichnen(korb) {
    var summe = document.querySelector("[data-gs-zwischensumme]");
    if (summe) {
      var vorher = parseInt(summe.getAttribute("data-gs-wert") || "0", 10);
      hochzaehlen(summe, vorher, korb.total_price);
      summe.setAttribute("data-gs-wert", korb.total_price);
    }
    var anzahl = document.querySelector("[data-gs-korb-anzahl]");
    if (anzahl) anzahl.textContent = korb.item_count;
    zahlImKopf(korb.item_count);
    fortschritt(korb);
  }

  function aktualisieren(korb) {
    zeilenZeichnen(korb);
    summenZeichnen(korb);
    vorschlaegeAusblenden(korb);
  }

  function vorschlaegeAusblenden(korb) {
    var drin = korb.items.map(function (p) { return String(p.product_id); });
    var karten = document.querySelectorAll("[data-gs-vorschlag-produkt]");
    for (var i = 0; i < karten.length; i++) {
      var id = karten[i].getAttribute("data-gs-vorschlag-produkt");
      karten[i].style.display = drin.indexOf(id) >= 0 ? "none" : "";
    }
  }

  /** Den gerade hinzugefügten Posten anhand seiner Variante finden. */
  function zuletzt(korb, variante) {
    var treffer = (korb.items || []).filter(function (p) {
      return String(p.variant_id) === String(variante);
    });
    return treffer.length ? treffer[0] : (korb.items || [])[korb.items.length - 1];
  }

  function beschaeftigt(el, an) {
    if (!el) return;
    el.classList.toggle("ist-beschaeftigt", !!an);
    el.disabled = !!an;
  }

  /* ----------------------------------------------------------------- Start */

  document.addEventListener("DOMContentLoaded", function () {
    var wurzel = document.querySelector("[data-gs-korb]");
    if (wurzel && wurzel.getAttribute("data-gs-geldformat")) {
      format = wurzel.getAttribute("data-gs-geldformat");
    }

    /* Menge ändern */
    document.addEventListener("click", function (e) {
      var knopf = e.target.closest ? e.target.closest("[data-gs-menge]") : null;
      if (!knopf) return;
      e.preventDefault();
      var zeile = knopf.closest("[data-gs-zeile]");
      if (!zeile) return;
      var schluessel = zeile.getAttribute("data-gs-zeile");
      var jetzt = parseInt(zeile.querySelector("[data-gs-menge-feld]").value, 10) || 0;
      var neu = knopf.getAttribute("data-gs-menge") === "plus" ? jetzt + 1 : jetzt - 1;
      if (neu < 0) return;
      beschaeftigt(knopf, true);
      aendern(schluessel, neu)
        .then(aktualisieren)
        .catch(function () { window.location.reload(); })
        .then(function () { beschaeftigt(knopf, false); });
    });

    /* Position entfernen */
    document.addEventListener("click", function (e) {
      var knopf = e.target.closest ? e.target.closest("[data-gs-entfernen]") : null;
      if (!knopf) return;
      e.preventDefault();
      var zeile = knopf.closest("[data-gs-zeile]");
      if (!zeile) return;
      beschaeftigt(knopf, true);
      aendern(zeile.getAttribute("data-gs-zeile"), 0)
        .then(function (korb) {
          zeile.style.height = zeile.offsetHeight + "px";
          void zeile.offsetWidth;
          zeile.classList.add("ist-weg");
          window.setTimeout(function () {
            zeile.remove();
            aktualisieren(korb);
          }, 300);
        })
        .catch(function () { window.location.reload(); });
    });

    /* Vorschlag in den Warenkorb */
    document.addEventListener("click", function (e) {
      var knopf = e.target.closest ? e.target.closest("[data-gs-dazu]") : null;
      if (!knopf) return;
      e.preventDefault();
      var variante = knopf.getAttribute("data-gs-dazu");
      var vorher = knopf.textContent;
      beschaeftigt(knopf, true);
      knopf.textContent = knopf.getAttribute("data-gs-laeuft") || "Adding…";
      flug(knopf);
      hinzufuegen(variante, 1)
        .then(function () { return holen(); })
        .then(function (korb) {
          knopf.textContent = knopf.getAttribute("data-gs-fertig") || "Added";
          if (document.querySelector("[data-gs-korb-zeilen]")) {
            window.setTimeout(function () { window.location.reload(); }, 450);
          } else {
            aktualisieren(korb);
            bestaetigung(zuletzt(korb, variante), korb);
            window.setTimeout(function () {
              knopf.textContent = vorher;
              beschaeftigt(knopf, false);
            }, 1800);
          }
        })
        .catch(function () {
          knopf.textContent = vorher;
          beschaeftigt(knopf, false);
        });
    });

    /* Produktformular: hinzufügen ohne Neuladen */
    var formulare = document.querySelectorAll('form[action*="/cart/add"]');
    for (var f = 0; f < formulare.length; f++) {
      formulare[f].addEventListener("submit", function (e) {
        var form = this;
        var knopf = form.querySelector('button[type="submit"]');
        var daten = new FormData(form);
        var id = daten.get("id");
        if (!id) return; /* ohne Variante lieber der normale Weg */
        e.preventDefault();
        var vorher = knopf ? knopf.textContent : "";
        if (knopf) { beschaeftigt(knopf, true); knopf.textContent = T.wird_hinzugefuegt || "Adding…"; }
        flug(knopf);
        hinzufuegen(id, parseInt(daten.get("quantity"), 10) || 1)
          .then(function () { return holen(); })
          .then(function (korb) {
            summenZeichnen(korb);
            bestaetigung(zuletzt(korb, id), korb);
            if (knopf) {
              knopf.textContent = T.hinzugefuegt || "Added";
              window.setTimeout(function () {
                knopf.textContent = vorher;
                beschaeftigt(knopf, false);
              }, 1800);
            }
          })
          .catch(function () { form.submit(); });
      });
    }

    /* Erstanzeige der Schwelle */
    if (wurzel) holen().then(summenZeichnen).catch(function () {});
  });

  window.GSKorb = { geld: geld, holen: holen, aendern: aendern, hinzufuegen: hinzufuegen };
})();
